import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommentsModule } from '@helios/comments'
import { CreateTransactionsModalModule } from '@helios/create-transactions-modal'
import { FilterModalModule } from '@helios/filter-modal'
import { GenericComponentsModule } from '@helios/generic-components'
import { TelemetryService } from '@helios/telemetry'
import {
  NgbAlertModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import { NfFormsModule, ToastModule } from '@northfork/ng-basics'
import { DifferenceGetterService } from '../../services/difference-getter/difference-getter.service'
import { ExternalTransactionsService } from '../../services/external-transactions.service'
import { TransactionModalModule } from '../transaction-modals'
import { ClearwaterTransactionsGridComponent } from './clearwater-transactions-grid.component'

@NgModule({
  declarations: [ClearwaterTransactionsGridComponent],
  imports: [
    // Angular Modules
    CommonModule,
    FormsModule,
    NgbModalModule,
    NgbDropdownModule,
    ReactiveFormsModule,

    // Third Party Modules
    NgSelectModule,
    NgbTooltipModule,

    // Northfork Modules
    NfFormsModule,
    TableLayoutModule,
    ToastModule,

    // Helios Modules
    TransactionModalModule,
    CreateTransactionsModalModule,
    GenericComponentsModule,
    FilterModalModule,
    NgbAlertModule,
    CommentsModule,
  ],
  exports: [ClearwaterTransactionsGridComponent, NgbDropdownModule],
  providers: [
    DifferenceGetterService,
    ExternalTransactionsService,
    TelemetryService,
  ],
})
export class ClearwaterTransactionsGridModule {}
